<template>
  <div ref="recaptchaContainer"></div>
</template>

<script>
export default {
  props: {
    siteKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      widgetId: null,
    };
  },
  mounted() {
    
    // Charger le script si nécessaire
    if (typeof window.grecaptcha === "undefined") {
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js?onload=initRecaptcha&render=explicit";
      script.async = true;
      script.defer = true;
      window.initRecaptcha = this.renderRecaptcha;
      document.body.appendChild(script);
    } else {
      this.renderRecaptcha();
    }
  },
  methods: {
    renderRecaptcha() {
      if (window.grecaptcha && this.$refs.recaptchaContainer) {
        this.widgetId = window.grecaptcha.render(this.$refs.recaptchaContainer, {
          sitekey: this.siteKey,
        });
      }
    },
    getResponse() {
      if (window.grecaptcha && this.widgetId !== null) {
        return window.grecaptcha.getResponse(this.widgetId);
      }
      return null;
    },
    reset() {
      if (window.grecaptcha && this.widgetId !== null) {
        window.grecaptcha.reset(this.widgetId);
      }
    },
  },
};
</script>
